import { FS, IS_PROD } from 'venn-utils';
import { RiskProHelpCenterDev, RiskProHelpCenterProd } from '../../../green/RiskProHelpCenterLinks';
import { getCurrentTheme } from '../../getCurrentTheme';
import type { IHelpCenterLinks } from '../../getTextThemeProvider';
import { getTextThemeProvider } from '../../getTextThemeProvider';

const servesMigratedHelpCenter = () => FS.has('venn_help_on_riskpro_ff') && getCurrentTheme() === 'green';

/**
 * Each Risk Pro help center is a separate Intercom import with its own article ids, so the
 * environment picks the map rather than only the host.
 */
const resolveTextProvider = () =>
  servesMigratedHelpCenter() ? (IS_PROD ? RiskProHelpCenterProd : RiskProHelpCenterDev) : getTextThemeProvider();

/**
 * Resolved once rather than on every read: FS.has reports to Sentry while the feature flag map is
 * still loading, which every link read would then repeat.
 */
let links = getTextThemeProvider().HelpCenterLinks;
let helpCenterUrl = getTextThemeProvider().HelpCenterUrl;

export const getHelpCenterLinks = (): IHelpCenterLinks => links;

export const getHelpCenterUrl = (): string => helpCenterUrl;

/**
 * Feature flags are fetched asynchronously, so the links captured when this module is evaluated cannot account for
 * venn_help_on_riskpro_ff. Call this once the flag map is available to re-resolve every link.
 */
export const refreshHelpCenterLinks = () => {
  const provider = resolveTextProvider();
  links = provider.HelpCenterLinks;
  helpCenterUrl = provider.HelpCenterUrl;
};
